import * as React from 'react'

import { Inputs } from 'react-use-form-state'

export { default as ErrorText } from './error-text'
export { default as Label } from './label'
export { default as LabelText } from './label-text'
export { default as RadioBox } from './radio-box'
export { default as Select } from './select'
export { default as Text } from './text'
export { default as Toggle } from './toggle'

export type Validity = 'valid' | 'invalid' | 'unknown'

export interface IFormState {
  errors?: { [key: string]: string | undefined }
  touched: { [key: string]: boolean | undefined }
  validity: { [key: string]: boolean | undefined }
  reset: () => void
}

export interface IFormInput<T> {
  input: Inputs<T>
  errorMessage?: string
  errorCollapse?: 'dynamic' | 'fixed'
  label?: React.ReactNode
  name: keyof T
  valid?: Validity
  validate?: (value: string) => boolean | string
  validateOnBlur?: boolean
}

export function getValidity(formState: IFormState, field: string): Validity {
  return formState.touched[field] ? (formState.validity[field] ? 'valid' : 'invalid') : 'unknown'
}
